<template>
    <templatePublicComponent>
        <div>
            <h3>Services :</h3>
            <div class="content">
                <h5>Procédure pour le service de déneigement</h5>
                <p>Si vous avez l’habitude de pelleter la neige qui s’accumule devant
                    votre porte de garage ou sur vos marches, veuillez SVP la déposer au
                    centre de votre stationnement et ce avant que le chauffeur ait terminé le
                    nettoyage complet de votre entrée.
                </p>
                <h5>Pour une neige de 4 cm. et plus:</h5>
                <ol>
                    <li>Les chasses neiges de la ville passent dans les rues. </li>
                    <li>Par la suite nous passons dans votre entrée pour enlever la bande de
                        neige qui s'est accumulée au passage de celui-ci.
                    </li>
                    <li>Vous devez à partir de ce moment enlever vos voitures afin que nous
                        puissions faire le déneigement complet.
                    </li>
                    <li>Nous entamons pour une deuxième fois faire le déneigement
                        complet.
                    </li>
                </ol>
                <h5>Pendant une tempête: </h5>
                <ol>
                    <li>Les chasses neige de la ville passent dans les rues. </li>
                    <li>Par la suite nous passons dans votre entrée pour enlever la bande de
                        neige qui s'est accumulée au passage de celui-ci.
                    </li>
                    <li>Si vos voitures ne sont pas dans l'entrée, le déneigeur va nettoyer
                        votre entrée.
                    </li>
                    <li>N'oubliez pas que votre entrée ne sera propre que lorsque la neige
                        aura cessé de tomber.
                    </li>
                    <li>Nous continuerons ainsi jusqu'à ce que la neige cesse.</li>
                    <li>Lorsque la neige cesse, les chasses neige passent dans les
                        rues.
                    </li>
                    <li>Par la suite nous passons dans votre entrée pour enlever la bande de
                        neige qui s'est accumulée au passage de celui-ci.
                    </li>
                    <li>Vous devez à partir de ce moment enlever vos voitures afin que nous
                        puissions faire le déneigement complet.
                    </li>
                    <li>Nous entamons pour une deuxième fois faire le déneigement
                        complet.
                    </li>
                </ol>
                <h5>Règlement municipal :</h5>
                <ul>
                    <li>
                        <a href="https://www.ville.sainte-catherine.qc.ca/citoyens/stationnement-hivernal/">Stationnement hivernal pour Ville de Ste-Catherine</a>
                    </li>
                    <li>
                      En vigueur du 1er décembre au 1er avril de minuit à 7h.
                    </li>
                    <li>
                      NEIGE OU PAS, APPELEZ CHAQUE SOIR avant de laisser votre véhicule stationné en bordure de la rue.
                    </li>
                    <li>
                      Dès 17h, 450 632-0590 option 9
                    </li>

                </ul>
            </div>
        </div>
    </templatePublicComponent>
</template>

<script>
import FrameComponent from '../components/Frame.vue'
import TemplatePublicComponent from '../components/TemplatePublic.vue'
export default {
  components:
  {
    FrameComponent,
    TemplatePublicComponent
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Services.vue